import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import getName from "../../components/common/Name";
import getPhone from "../../components/common/Phone";

const getPersonMinDetail = (node, index, props, keySuffix, type) => {
  const nameNode = _.get(node, "names[0].name[0]");
  let age = _.get(node, "age[0]._", "");
  if (age === "") {
    age = _.get(node, "DOBInfo[0].age[0]._");
  }
  let phone = _.get(node, "phones[0].phone[0]._", "");
  if (phone === "") {
    phone = _.get(node, "phone[0]._", "");
  }
  let apt = _.get(
    node,
    "addresses[0].address[0].unitDesignatorNumber[0]._",
    ""
  );
  if (apt === "") {
    apt = _.get(node, "address[0].unitDesignatorNumber[0]._", "");
  }
  return (
    <Table.Row
      key={`rep_pers_row_${type}_${index}_${keySuffix}`}
      className={index % 2 === 1 ? "table-row-odd-child" : ""}
    >
      <Table.Cell>
        <span className="text-bold">Name:</span>
      </Table.Cell>
      <Table.Cell>
        {nameNode
          ? getName(
              _.get(nameNode, "firstName[0]._", ""),
              _.get(nameNode, "middleName[0]._", ""),
              _.get(nameNode, "lastName[0]._", ""),
              props
            )
          : getName(
              _.get(node, "firstName[0]._", ""),
              _.get(node, "middleName[0]._", ""),
              _.get(node, "lastName[0]._", ""),
              props
            )}
      </Table.Cell>
      {age !== "" && (
        <Table.Cell>
          <span className="text-bold">Age:</span>
        </Table.Cell>
      )}
      {age !== "" && <Table.Cell>{age}</Table.Cell>}
      {phone !== "" ? (
        <Table.Cell>
          <span className="text-bold">Phone:</span>
        </Table.Cell>
      ) : (
        <Table.Cell />
      )}
      {phone !== "" ? (
        <Table.Cell>
          {getPhone(phone, props)}
          {apt !== "" && <span className={"text-bold"}> Apt: {apt}</span>}
        </Table.Cell>
      ) : (
        <Table.Cell />
      )}
    </Table.Row>
  );
};
export default getPersonMinDetail;



// WEBPACK FOOTER //
// ./src/components/reports/PersonMinDetail.js